import { observable, action, useStrict } from 'mobx';
import resultListStore from './resultListStore';
import checkListStore from './checkListStore';
const querystring = require('querystring');

useStrict(true);

class BannerTop {
  @observable showSuffix
  @observable inputDomain
  @observable suffix

  constructor() {
    this.params = querystring.parse(window.location.search.slice(1));
    this.showSuffix = false;
    this.suffix = this.params.suffix ? this.params.suffix.slice(1) : ' ';
    this.keyword = this.params.keyword ? this.params.keyword : '';
    this.constitute = this.params.constitute ? this.params.constitute : ' ';
    this.minLength = this.params.length ? this.params.length : ' ';
    this.maxLength = this.minLength;
    this.sortType = this.params.sortType ? this.params.sortType : '';
    this.sortBy = this.params.sortBy ? this.params.sortBy : '';
    this.allowRegistered = this.params.allowRegistered ? this.params.allowRegistered : '2';
  }

  @action
  handlerInputChange(s, event) {
    this.inputDomain = event.target.value;
    if (!this.inputDomain) {
      resultListStore.fetchresultList({
        'suffix': ' ',
        'keyWord': ' ',
        'constitute': ' ',
        'length': ' '
      });
      checkListStore.handlerCleanCheck();
      return;
    }
    const searchValue = this.inputDomain;
    this.keyword = searchValue ? searchValue.split('.')[0] : '';
    this.suffix = searchValue.indexOf('.') > -1 ? searchValue.slice(searchValue.indexOf('.') + 1) : ' ';
  }
}
export default new BannerTop;


// WEBPACK FOOTER //
// ./src/store/bannerTopStore.js